











import { Component, Prop, Vue } from 'vue-property-decorator';
import { DeviceType, appModule } from '@/store/modules/ModuleApp';
import SceneMixins from '@/libs/LibsModelSceneMixins';
import { mixins } from 'vue-class-component';

@Component
/** button组件 */
export default class ComponentFooter extends mixins(SceneMixins) {
	@Prop()
	public entranceFlag!: any;

	/** 是否显示面包屑 */
	public get showBreads(): boolean {
		return appModule.showBreads;
	}

	/** get year */
	public get year(): string {
		// eslint-disable-next-line newline-per-chained-call
		return new Date().getFullYear().toString();
	}
}
